import { CreatePasswordModel } from './../../shared/user.model';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-create-passwordph',
  templateUrl: './create-passwordph.component.html',
  styleUrls: ['./create-passwordph.component.css']
})
export class CreatePasswordphComponent implements OnInit {
  formSubmitted: boolean;
  title="Add New Password";
  user:CreatePasswordModel;
  IsServiceHavingPhone: any;
  UserId: string;
  isSMSResent: any;

  constructor(private errorHandler:ErrorHandler,private route: ActivatedRoute,private userService: RegistrationService) {
    this.formSubmitted = false;
    this.user=new CreatePasswordModel;
  }

  ngOnInit() {
    this.route.params.subscribe(params => {      
      this.UserId = params['UserId'];
      this.IsServiceHavingPhone= params['IsServiceHavingPhone'];
    });
  }
  onSubmit(form:NgForm){    
    if (!form.invalid) 
    {              
      debugger;
      this.user.UserId = this.UserId;
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.ResetPasswordPh(this.user).subscribe(
      (data:any) => {
        debugger;
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Password changed successfully!','success');
        //this.router.navigate(['/home/accounthead']);        
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });       
    }
    else
    {
      this.formSubmitted = true;
    }
  }

  ResendOTP(form:NgForm)
  {
   /* form.controls["OTP"].clearValidators();
    form.controls["OTP"].updateValueAndValidity();
    form.controls["Password"].clearValidators();
    form.controls["Password"].updateValueAndValidity(); 
    form.value.OTP=null;*/
    //document.getElementById('OTP').value = "";
    //this.OTP = ' ' ;
    document.getElementById('loader-spinner').style.display = "block";
    swal("warning!", this.UserId);
    this.userService.resendSMS(this.UserId).subscribe(
      (response:any) => {
        this.isSMSResent = response;
        //form.value.IsServiceHavingPhone = response;
        if (this.isSMSResent == true)
        {
          swal("success","OTP is resent","success");
        }
        else
        {
          swal("warning!","OTP is not sent.Try again.","warning");
        }
        //swal("warning!",this.isServiceNoHavingPhone.toString(), "warning");
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('',error.error.Message);
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/registration/create-passwordph/create-passwordph.component.ts